/**
 * Champ de mot de passe avec un bouton « Afficher » / « Masquer » (demande de Benjamin, 2026-10-25 : « avec des mots de
 * passe à rallonge, c'est un peu compliqué »). Le texte n'est jamais montré d'office ; le bouton est un vrai bouton
 * (`type="button"`, il ne soumet pas le formulaire) et dit son état aux lecteurs d'écran.
 */
import { useState } from 'react';

export function ChampMotDePasse({
  id,
  value,
  onChange,
  autoComplete,
  autoFocus,
  required,
}: {
  id?: string;
  value: string;
  onChange: (valeur: string) => void;
  autoComplete: 'current-password' | 'new-password';
  autoFocus?: boolean;
  required?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="mot-de-passe">
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        autoComplete={autoComplete}
        autoCapitalize="none"
        autoCorrect="off"
        spellCheck={false}
        autoFocus={autoFocus}
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <button
        type="button"
        className="secondaire mot-de-passe-voir"
        aria-pressed={visible}
        aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
        onClick={() => setVisible((v) => !v)}
      >
        {visible ? 'Masquer' : 'Afficher'}
      </button>
    </div>
  );
}
